module.exports = __webpack_public_path__ + "static/level_up_large-39c0cd903eaabd20aba8e16425e6aa84.svg";